import '.e3{font-size:1.125rem;}.ssr-plugin'
import '.ec{line-height:1.75rem;}.ssr-plugin'
import '.id{text-decoration:none;}.ssr-plugin'
import '.ft{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="e3 ec"
    >
      {translations.privacySubtitle}{' '}
      <a className="id ft"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="id ft"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
